<template>
  <div class="allprod">
    <div class="main">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="companyId"
          :options="option1"
          @change="changed"
        />
        <van-dropdown-item
          v-model="productTypeId"
          :options="option2"
          @change="changed"
        />
      </van-dropdown-menu>
      <div class="list">
        <van-divider />
        <van-list
          v-model="listLoading"
          :finished="listFinished"
          :finished-text="list.length > 0 ? '没有更多了' : '暂无产品'"
          @load="getinsurance"
          :offset="500"
          >
          <van-empty v-if="list.length == 0" />
          <van-cell v-for="(item, index) in list" :key="index" v-else>
            <div class="item flex">
              <img src="../../assets/img/san.png" alt="" />
              <div class="title">{{item.remarks?`(${item.remarks})`:''}}{{ item.productName }}</div>
              <div class="detail_btn" @click="todetail(item)">
                查看 <van-icon name="arrow" />
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { productType, company, product, userinfo, insurance } from "@/api/apis";
import {setyoumeng} from '../../utils/index'
export default {
  data() {
    return {
      companyId: "",
      productTypeId: "",
      option1: [{ text: "全部保险公司", value: "" }],
      option2: [{ text: "全部保险", value: "" }],
      listFinished: false,
      listLoading: false,
      list: [],
      page: 0,
    };
  },
  methods: {
    todetail(item) {
      console.warn(item);
      this.$router.push({ path: "/prodetail", query: { id: item.id } });
    },
    onLoad() {
      console.log(111);
    },
    getcomany() {
      let data = {
        page: 0,
        size: 99,
        sort: "id,asc",
      };
      company(data).then(async (res) => {
        let arr = await res.content.map((item, index) => {
          return {
            text: item.name,
            value: item.id,
          };
        });
        this.option1 = this.option1.concat(arr);
      });
    },
    getype() {
      let data = {
        page: 0,
        size: 99,
        sort: "id,asc",
      };
      productType(data).then(async (res) => {
        let arr = await res.content.map((item, index) => {
          return {
            text: item.name,
            value: item.id,
          };
        });
        console.log(arr);
        this.option2 = this.option2.concat(arr);
      });
    },
    getinsurance() {
      // debugger;
      // if (this.finished) {
      //   return;
      // }
      // // debugger;
      // if (this.loading) {
      //   return;
      // }
      // debugger;
      let that = this;
      let data = {
        companyId: this.companyId,
        productTypeId: this.productTypeId,
        enabled: true,
        sort: "id,desc",
        size: 10,
        page: this.page,
      };
      this.listLoading = true;
      insurance(data).then((res) => {
        console.log(res);
        that.listLoading = false;
        if (res.content.length > 0) {
          that.list = that.list.concat(res.content);
          that.page++;
          // if(this.list.length==res.totalElements)this.finished=true
        } else {
          that.listFinished = true;
        }
      });
    },
    changed() {
      this.page = 0;
      this.finished = false;
      this.list = [];
      this.getinsurance();
    },
  },
  mounted() {
    setyoumeng("https://v1.cnzz.com/z_stat.php?id=1279766185&web_id=1279766185")
    this.getype();
    this.getcomany();
    // this.getinsurance();
  },
};
</script>
<style lang="less" \>
.allprod {
  width: 100%;
  height: 100vh;
  position: relative;
  .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .main {
    width: 359px;
    border-radius: 3px;
    text-align: center;
    margin: 15px auto 0;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    .van-dropdown-menu__title {
      color: rgba(153, 159, 164, 100) !important;
    }
    .list {
      height: 100%;

      .item {
        img {
          width: 30px;
          height: 30px;
        }
        .title {
          width: 222px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          color: rgba(16, 16, 16, 100);
          font-size: 17px;
          text-align: left;
          font-family: SourceHanSansSC-regular;
          margin-left: 14px;
        }
        .detail_btn {
          width: 54px;
          height: 21px;
          line-height: 20px;
          border-radius: 100px;
          color: rgba(153, 159, 164, 100);
          font-size: 11px;
          text-align: center;
          font-family: Roboto;
          border: 1px solid rgba(187, 187, 187, 100);
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 3px;
        }
      }
    }
  }
}
</style>